import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'first90-page-stats',
  templateUrl: './stats-page.component.html',
  styleUrls: ['./stats-page.component.scss']
})
export class StatsPageComponent { }
